import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-single-news',
  template: `<ngx-one-column-layout>
               <router-outlet></router-outlet>
            </ngx-one-column-layout>`,
  styleUrls: ['./single-news.component.scss']
})
export class SingleNewsLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}

